<template>
  <div id="app">
    <v-app>
      <v-app-bar
        app 
        dense
        dark 
        clipped-left
      >
      </v-app-bar>
      <v-content >
        <v-container fluid fill-height class='pa-0 ma-0'>
          <v-row class='pa-0 ma-0'>
            <v-col class='pa-0 ma-0'>
              <ProgressSpinner 
                :isLoading="isLoading"
                :forceHideLoader="forceHideLoader"
                backgroundColor="#000"
              />

              <router-view 
                :app="{
                  restApi,
                  isLoading,
                  setForceHideLoader,
                  reset,
                }"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-content>
    </v-app>
  </div>
</template>

<script>
import axios from 'axios'
import env from '../server.config'
import ProgressSpinner from './components/loaders/ProgressSpinner'

export default {
  name: "App",
  components: {
    //Title,
    ProgressSpinner,
  },
  data() {
    return {
      restApi: {},
      isLoading_: 0,
      forceHideLoader_: false,
    }
  },
  computed: {
    isLoading: {
      get() {
        return this.isLoading_
      },
      set(val) {
        this.isLoading_ = val
      },
    },
    forceHideLoader: {
      get() {
        return this.forceHideLoader_
      },
      set(val) {
        this.forceHideLoader_ = val
      },
    }
  },
  mounted() {
    console.log("App::mounted")

    // initialize api using session cookies
    this.restApi = axios.create({
      baseURL: env.apiBaseUrl,
      withCredentials: true // use session cookies
    })

    // before a request is made start the nprogress
    this.restApi.interceptors.request.use(config => {
      this.isLoading++
      return config
    })

    // before a response is returned stop nprogress
    this.restApi.interceptors.response.use(
      response => {
        if (this.isLoading > 0) {
          this.isLoading--
        }
        return response
      },
      error => {
        this.isLoading = 0;
        // 401 is JWT validation error
        // 410 is PHP session invalid
        if (401 === error.response.status || 410 === error.response.status) {
          if (Object.keys(this.userProfile).length > 0){
            // Only do this once - we may have made multiple API calls that will fail
            alert(`Your session has expired. You will be redirected to the login page. (${error.response.status})`)
            this.reset()
            this.$router.push("/login")
          } else {
            return error
          }
        } else {
          // this propagates error to catch() at caller
          return Promise.reject(error)
        } 
      }
    )
  },
  methods: {
    // clear auth and app state
    reset() {
    },
    setErrorMessage(val) {
      this.errorMessage = val
    },
    setForceHideLoader(val) {
      this.forceHideLoader = val
    }
  },
}
</script>

<style>
/* import global classes */
@import './assets/css/styles.css';

.body-content {
  max-width: 100%;
  padding: 0px;
}
</style>